import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";

// Note: service-worker/cache cleanup for the shared-origin dev case lives in the
// inline <head> script in index.html so it runs before this bundle. This app never
// registers a service worker itself.

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);